export const Roles = {
    USER: 'User',
    TEACHER: 'Teacher',
    MANAGER: 'Manager',
    ADMINISTRATOR: 'Administrator',
};